import {api} from "../utils/gashtaltAPI";
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";

function DeleteModal({isOpen, onClose, Delete}) {
    const handleSubmit = async (e) => {
        Delete();
        onClose();
    }
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>حذف</ModalHeader>
                <ModalCloseButton/>
                <ModalBody className="exam-modal">
                    <p>آیا از حذف این مورد اطمینان دارید؟</p>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme='gray' mr={3} onClick={onClose} marginX={'1rem'}>
                        بستن
                    </Button>
                    <Button colorScheme='red' onClick={handleSubmit}>حذف</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default DeleteModal;